export default __webpack_public_path__ + "static/media/logo.4b0c4fc8.png";